export const environment = {
  production: false,
  analytics: false,
  amazonAwsBucketName: 'testing-bit4m',
  amazonAwsBucketNamePlaceholder: '{bucketname-placeholder}',
  analyticsTag: 'UA-79356844-1',
  googleMapsApiKey: 'AIzaSyB3Pc9egdsPP5OMXzYxWywnRJ1g5QqIuCA',
  cdnAddress: 'files.lobbit.app'
};
